import pluginRegistry from '../../plugin/PluginProvider';

export function isDieselRoute(plugin) {
    return (plugin && plugin.dieselRoutePlugin) || false;
}

export default (component, options = {}) => {
    component.dieselRoutePlugin = true;
    component.getDieselRouteDefinition = () => ({
        path: options.path,
        exact: options.isExactRoute || false,
        component
    });
    pluginRegistry.providePlugin(component);

    return component;
};
